module.exports = __webpack_public_path__ + "static/img/dataviz.93c3d90.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/projets/dataviz.jpg
// module id = B26X
// module chunks = 1